var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 110,
    viewBox: "0 0 117 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "z9kwqvclta",
    x1: "117.895%",
    x2: "33.573%",
    y1: "-2.72%",
    y2: "72.442%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#37C07E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#z9kwqvclta)",
    d: "M116.48 57.804L62.875 109.66 0 40.959 40.875 0z",
    opacity: 0.4,
    transform: "translate(-810 -1222) translate(810 1222)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1FFF8",
    d: "M41 0L116 0 116 57 41 57z",
    transform: "translate(-810 -1222) translate(810 1222)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1FFF8",
    d: "M58 24H98V64H58z",
    transform: "translate(-810 -1222) translate(810 1222)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37C07E",
    fillRule: "nonzero",
    d: "M98.732 23.505H57.63V64h41.102V23.505zm-1.257 1.23v38.151H58.888V24.735h38.587zM116.48 0H40v57.804h15.01v-1.23H41.256V12.7h73.966v43.874h-13.87v1.23h15.127V0zm-6.464 17.627h-63.67v1.23h63.67v-1.23zm5.207-16.397v10.24H41.257V1.23h73.966zm-13.67 4.505h-1.257v1.23h1.257v-1.23zm4.466 0h-1.257v1.23h1.257v-1.23zm4.467 0h-1.258v1.23h1.258v-1.23zm-15.632 0h-47.92v1.23h47.92v-1.23z",
    transform: "translate(-810 -1222) translate(810 1222)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceicon2);
export default __webpack_public_path__ + "static/media/serviceicon2.b9bc5c47080e0a6fcca7fe372b621535.svg";
export { ForwardRef as ReactComponent };